module.exports = "https://img.zhijierongxing.com/saas/img/mine_menu4.417b5053.png";